import { render, staticRenderFns } from "./commitSubordinateDialog.vue?vue&type=template&id=b9bafd88&scoped=true"
import script from "./commitSubordinateDialog.vue?vue&type=script&lang=js"
export * from "./commitSubordinateDialog.vue?vue&type=script&lang=js"
import style0 from "./commitSubordinateDialog.vue?vue&type=style&index=0&id=b9bafd88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bafd88",
  null
  
)

export default component.exports